module.exports = __webpack_public_path__ + "img/KCB-Web-Logo-768x682.3b8e2b46.png";